<template>
  <div>
    <div  v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" class="form-control-select" v-model="idDelModelo" @change="cambiarDatos($event)" :disabled="deshabilitado">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un estatus de la cita</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los estatus de las citas</option>
        <option v-for="TipoEstatusDeCita in TiposEstatusDeCitas" :value="TipoEstatusDeCita.TipoEstatusDeCitaId" :key="TipoEstatusDeCita.TipoEstatusDeCitaId">{{TipoEstatusDeCita.Nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        TiposEstatusDeCitas: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String 
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object,
      deshabilitado: false
    },
    mounted() {      
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      
      this.$store.dispatch("A_SICCIJ_Catalogo_Establecer012TipoEstatusDeCita", parametros);
    },
    methods: {
      cargaCatalogoTiposEstatusDeCitas() {        
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba      
                
        axios.post(api.conexion + api.SICCIJ.catalogos.C012TiposEstatusDeCitas, this.parametros)
          .then(respuesta => {            
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {              
              this.TiposEstatusDeCitas = respuesta.data.TiposEstatusDeCitas;

              if (this.parametros.filtros != undefined && this.parametros.filtros != null) {
                this.TiposEstatusDeCitas = respuesta.data.TiposEstatusDeCitas.filter(cond => this.parametros.filtros.some(tipo => tipo == cond.TipoEstatusDeCitaId));
              }
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        
        this.$store.dispatch("A_SICCIJ_Catalogo_Establecer012TipoEstatusDeCita", parametros);
        this.$emit("valorParaElPadre", evento);
        //evento.target[evento.target.selectedIndex].label esto sirve para obtener el label de valor actual
      }
    },
    created() {
      this.cargaCatalogoTiposEstatusDeCitas();
    }
  }
</script>

<style scoped>
.form-control-select {
        background-color: white;
        color: rgb(63, 62, 62);
        border: none;
        position: relative;
        top: 5px;
        left: 20px;
        width:210px ;
    }
</style>



// WEBPACK FOOTER //
// src/components/SICCIJ/Comun/Catalogos/012TiposEstatusDeCitas.vue